export default "__VITE_ASSET__CgH7ecwj__"